export default __webpack_public_path__ + "static/media/powered by stripe.7b88ce0c.png";